module.exports = {"pathContext":{"title":"QEMU 3.0 Released","createdAt":"20 hours ago","by":"pyprism","comments":[{"text":"Cool! Qemu + binfmt is magic","by":"xkcd-sucks","timeISO":"12 hours ago"}]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/comment-17767366.json
// module id = 871
// module chunks = 262171880954565